<template>
   <div id="_bannerMain">
    <Carousel
      class="myCarousel"
      v-model="Carousel.value3"
      :height="Carousel.setting.height"
      :autoplay="Carousel.setting.autoplay"
      :autoplay-speed="Carousel.setting.autoplaySpeed"
      :dots="Carousel.setting.dots"
      :radius-dot="Carousel.setting.radiusDot"
      :trigger="Carousel.setting.trigger"
      :arrow="Carousel.setting.arrow"
    >
      <CarouselItem
        v-for="(item,index) in bannerList"
        :key="index"
      >
        <div class="demo-carousel">
          <img
            :src="item?item.adPic:''"
            alt=""
          >
        </div>
      </CarouselItem>
    </Carousel>
  </div>
</template>
<script>
export default {

  data () {
    return {
      bannerList: [],
      Carousel: {
        value3: 0,
        setting: {
          height: 420,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: 'inside',
          radiusDot: false,
          trigger: 'click',
          arrow: 'hover'
        },
      },
    }
  },

  mounted () {
    // this.getList(2)
  },
  methods: {
    getList () {
      let queryUrl = `${this.baseURL}/sys/adPosition/v1/shop`
      queryUrl += '?' + this.QS.stringify({
        // access_token: this.token,
        url: window.location.hostname,
        pageNum: 1,
        pageSize: 10,
        orderBy: 'sort',
        sortIsDown: true
      })
      this.$http.post(queryUrl, { "adIndex": this.$route.query.Id }).then(res => {
        let Data = res.data;
        this.isShowLoading = false;
        if (Data.code === 200) {
          this.bannerList = Data.data.items
        }
      })
    }
  },
}
</script>
<style lang="less" scoped>
img {
  object-fit: cover;
  width: 100%;
  height: 420px;
}
</style>
<style scoped>
.myCarousel {
  min-width: 1200px;
}
.myCarousel >>> .ivu-carousel-dots-inside {
  bottom: 20px;
}
.myCarousel >>> .ivu-carousel-dots li {
  margin: 0 5px;
}
.myCarousel >>> .ivu-carousel-dots li button {
  background: rgba(255, 255, 255, 0.2);
  opacity: 0.8;
  border: 1px solid #ffffff;
  border-radius: 100px;
  width: 24px;
  height: 12px;
}
.myCarousel >>> .ivu-carousel-dots .ivu-carousel-active button {
  background: #4b7ff0;
  border: 1px solid #4b7ff0;
}
.myCarousel >>> .ivu-carousel-arrow.right {
  right: 120px;
}
.myCarousel >>> .ivu-carousel-arrow.left {
  left: 120px;
}
.myCarousel >>> .ivu-carousel-arrow {
  width: 64px;
  height: 64px;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.myCarousel >>> .ivu-icon {
  font-size: 40px;
}
</style>

